var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("message.parte")))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: !_vm.editable,
                      id: "codigo",
                      placeholder: "##"
                    },
                    model: {
                      value: _vm.form.codigo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "codigo", $$v)
                      },
                      expression: "form.codigo"
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.codigo")))]),
                    _vm._v(" "),
                    _vm.errores.codigo
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.codigo[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: { id: "descripcion" },
                    model: {
                      value: _vm.form.descripcion,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "descripcion", $$v)
                      },
                      expression: "form.descripcion"
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.descripcion")))]),
                    _vm._v(" "),
                    _vm.errores.descripcion
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.descripcion[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      vMoney: "",
                      format: _vm.money,
                      id: "valor",
                      placeholder: "Escriba el valor..."
                    },
                    model: {
                      value: _vm.form.valor,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "valor", $$v)
                      },
                      expression: "form.valor"
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.valor")))]),
                    _vm._v(" "),
                    _vm.errores.valor
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [_c("strong", [_vm._v(_vm._s(_vm.errores.valor[0]))])]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      vMoney: "",
                      format: _vm.decimal,
                      id: "valor",
                      placeholder: "Escriba el valor..."
                    },
                    model: {
                      value: _vm.form.horas_hombre,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "horas_hombre", $$v)
                      },
                      expression: "form.horas_hombre"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("message.horas_hombre")))
                    ]),
                    _vm._v(" "),
                    _vm.errores.horas_hombre
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.horas_hombre[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.guardar")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.cancelar")))])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3e844cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3e844cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/materiales/Material.vue
// module id = 367
// module chunks = 0